import { Cart } from '@idealsupply/ngclient-webservice-shopping-cart';
import { CartEntity } from './types/CartEntity';

export function cartIdToString(cart: CartEntity | Cart): string {
  return `${cart.type}|${cart.customerNumber}`;
}
